export default "__VITE_ASSET__BIhVRrDa__"